(function () {
  var bar = document.querySelector('[data-meroo-sticky-atc], .meroo-sticky-atc');
  if (!bar) return;

  var buyButtons = document.querySelector('.meroo-pdp .product-form__buttons, .product-form__buttons, product-form');
  if (!buyButtons || !('IntersectionObserver' in window)) {
    return;
  }

  if (window.matchMedia('(min-width: 750px)').matches) {
    bar.hidden = true;
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          bar.hidden = true;
          bar.classList.remove('is-visible');
        } else {
          bar.hidden = false;
          bar.classList.add('is-visible');
        }
      });
    },
    { threshold: 0, rootMargin: '0px 0px -8px 0px' }
  );

  observer.observe(buyButtons);
})();
